import { Timer } from "assets/icons";
import {
  DropdownSetting,
  InformationSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";
import { getSoundsArray } from "util/getSoundsArray";

import { InteractiveTimer, InteractiveTimerState } from "./Timer";

export const InteractiveTimerWidget: WidgetType<InteractiveTimerState> = {
  name: "Timer",
  component: InteractiveTimer,
  icon: Timer,
  showOnToolbar: true,
  sizing: {
    minWidth: 93,
    minHeight: 128,
    minAspectRatio: 0.5,
    maxAspectRatio: 0.8,
  },
  defaultState: {
    setTime: 600,
    currentTime: 600,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 20,
  },
  settings: {
    info: {
      editor: InformationSetting,
      info: {
        info: "Starts a timer that counts down and plays a sound when it is low and when it is finished.",
      },
    },
    showWarn: {
      editor: ToggleSetting,
      info: {
        label: "Show Timer Ending Warning",
      },
      defaultValue: true,
    },
    sound: {
      editor: ToggleSetting,
      info: {
        label: "Sound Effect",
      },
      defaultValue: true,
    },
    selectSound: {
      editor: DropdownSetting,
      info: {
        name: "Select Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.timer,
        widgetDisplayName: "Timer",
      },
    },
  },
};
